import { render } from "./PublicPageContainer.vue?vue&type=template&id=ca5f25ee"
import script from "./PublicPageContainer.vue?vue&type=script&lang=js"
export * from "./PublicPageContainer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__